import {useContext} from 'react';
import {useMutation} from '@apollo/client';

import {LOG_OUT} from './../../../graphql/mutations';
import {UserContext} from './../../../contexts/user-context';
import {
  removeUserToken,
  removeUserHash,
  removeUserEmail,
  removeUserName,
  removeNewUser,
  getRawCookie,
  sendUserDataToExtension,
} from './../../../helpers/index';

const useLogOut = () => {
  const {user, setUser, setHexofyUser} = useContext(UserContext);
  const [log_out] = useMutation(LOG_OUT);

  const logOut = async (): Promise<void> => {
    const {data} = await log_out({variables: {id: user?.id, device_key: getRawCookie('device_key')}});
    if (data && data.UserOps && data.UserOps.logout && !data.UserOps.logout.error) {
      removeUserToken();
      removeUserHash();
      removeUserEmail();
      removeUserName();
      removeNewUser();
      sendUserDataToExtension();
      setHexofyUser(null);
      setUser(null);
    }
  };
  return [logOut];
};

export default useLogOut;
